console.clear();

var pym = require("./lib/pym");
var ANALYTICS = require("./lib/analytics");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");
var { fmtComma, COLORS, wrapText } = require("./lib/helpers");
var debounce  = require("./lib/debounce");
var $ = require("./lib/qsa");

var { PI } = Math;

var d3 = {
  ...require("d3-array/dist/d3-array.min"),
  ...require("d3-axis/dist/d3-axis.min"),
  ...require("d3-scale/dist/d3-scale.min"),
  ...require("d3-selection/dist/d3-selection.min"),
  ...require("d3-force/dist/d3-force.min")
};

var pymChild = null;
pym.then(function(child) {
  pymChild = child;
  child.sendHeight();

  var render = function() {
    

    //run your D3 functions here

    //renderBeeswarm(container, containerWidth, 'here');

    var containerElement = document.querySelector(".graphicright");
    //remove fallback
    containerElement.innerHTML = "";

    var container = d3.select(containerElement);
    var containerWidth = containerElement.offsetWidth;
    //run your D3 functions here
    var config = {"key":"marketVal2","domainMax":24000000}
    // var config = {"key":"Acres","domainMax":250}

    renderBeeswarm(container, containerWidth,config);


    pymChild.sendHeight();
  };

  render();
  window.addEventListener("resize", render);


});

var renderBeeswarm = function(container, containerWidth, config) {

  var {key, domainMax} = config;

  var svg = container.append('svg'),
      margin = {top: 0, right:30, bottom: 10, left: 30},
      width = containerWidth,
      height = 180
      

  if (isMobile.matches) {
    height = 150;
    margin.left = 20;
    margin.right = 10;
  }

  var chartWidth = width - margin.left - margin.right;

  var chartHeight = height - margin.top - margin.bottom;

  // var highlightCountries = ['United States', 'South Korea']
  
  svg.attr("width", width)
    .attr("height", height)

  var defs = `<pattern id="diagonalHatch" patternUnits="userSpaceOnUse" width="8" height="8">
  <path class="hatcher" d="M-2,2 l4,-4
           M0,8 l8,-8
           M6,10 l4,-4" />
</pattern>`

  svg.append("defs")
    .html(defs)

  var yearRange = [new Date(2000, 0, 1),new Date(2023, 0, 1)];
  var circleMaxDomain = domainMax;

  var MAX_RADIUS = 40;
  if (isMobile.matches) {
    MAX_RADIUS = 30;
  }
  var MIN_RADIUS = 1;

  function nodeRadius(d) {
    var areaMax = PI*MAX_RADIUS**2;
    var ratioD = d/circleMaxDomain;
    var areaD = areaMax*ratioD;
    var rD = Math.sqrt(areaD / PI);
    return Math.max(rD,MIN_RADIUS);
  }

  var rScale = d3
    .scaleSqrt()
    .domain([0,circleMaxDomain])
    .range([1,MAX_RADIUS])

  var xScale = d3
    .scaleTime()
    .domain(yearRange)
    .range([0, chartWidth]).nice();

  var yScale = d3
    .scaleLinear()
    .domain([])
    .range([chartHeight, 0]);

  var g = svg.append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

  var data = DATA;
  var labels = LABELS;

  function collisionRadius(d) {
    return nodeRadius(d[key])+0.25;
  }

  var collider = d3.forceCollide(1)
  
  collider.radius(collisionRadius);

  var simulation = d3.forceSimulation(data)
      .force("x", d3.forceX(function(d) { return xScale(new Date(d.yearAdjusted)); })
      .strength(0.9))
      .force("y", d3.forceY(chartHeight / 1.8))
      .force("collide", collider)
      .stop();


  for (var i = 0; i < 1000; ++i) simulation.tick();

  var xTicks = 10;
  if (isMobile.matches) {
    xTicks = 5;
  }

  var xAxis = d3.axisTop()
              .scale(xScale)
              .ticks(xTicks)
              // .tickFormat(d => d);


    g.append("g")
        .attr("class", "axis axis--x x-axis")
        .attr("transform", "translate(0," + 0 + ")")
        .call(xAxis);
    // g.append("g")
    //     .attr("class", "axis")
    //     .attr("transform", "translate(" + chartWidth*.5 + ",0)")
    //     .call(yAxis);

    var cell = g.append("g")
        .attr("class", "cells")
        .selectAll("g").data(data.sort((a,b) => {
          if (a[key] < b[key]) {
            return 1
          } else {
            return -1
          }
        }))
      .enter()

      
    cell.append("circle")
        .attr("class", d => d.sID)
        .attr("id", "parcel-circle")
        .attr("r", (d,i) => nodeRadius(d[key]))
        .attr("cx", d => {
          // console.log(d)
          return d.x})
        .attr("cy", d => d.y)
        .attr("data-val", d => d.x)
        // .attr("fill-opacity",0.3)
        .attr("fill-opacity", d => {
          return d.donated ? 0.9 : 0.3
        })
        .attr("fill", d => {
          return d.donated ? "url(#diagonalHatch)" : "#02d2b7";
        })
        .attr("stroke", d => {
          return d.donated ? COLORS.teal3 : "#02d2b7";
        })
        .attr("stroke-width",2)
        .attr("parcel", d => d.sID)

    var bittylabels = g.append("g")
        .attr('class',"bittylabels")

    bittylabels.selectAll('text')
      .data(data.filter(d=> isMobile.matches ? d[key] > 4000000 : d[key] > 4000000))
      .enter().append("text")
        .attr('x', d => d.x)
        .attr('y', d => d.y)        
        .attr('dx', d => 0)
        .attr('dy', d => 4)
        .attr('class', d => "bittylabel")
        .text(d => `$${d[key]/1000000}M`)

  // Tooltips
  var chart = document.querySelector("#graphic");
  var tooltip = document.querySelector(".bubble-tooltip");
  var body = document.querySelector("body");    

  //hover triggers tooltip
  function onMove(e) {


    var bounds = chart.getBoundingClientRect();    
    var offsetX = e.clientX - bounds.left + (body.getBoundingClientRect().width-bounds.width)/2;

    var offsetY = e.clientY - 105;
    var parcel = e.target.getAttribute("parcel");
    var data = DATA.filter(d => d.sID == parcel) 

    console.log()
    if (e.target.nodeName != "svg") {
          // <div class="tooltip-label"><h3>${data[0].type}</h3></div>
      tooltip.innerHTML = `
          <div class="tooltip-label number">Price: <strong>$${fmtComma(data[0][key])}</strong></div>
          <div class="tooltip-label number">Acres: <strong>${data[0].Acres}</strong></div>
      `
      tooltip.classList.add("show");

      var left = offsetX < bounds.width / 2 ? offsetX + 10 : offsetX - 4 - tooltip.offsetWidth;
      tooltip.style.left = left + "px";
      tooltip.style.top = offsetY + 10 + "px";

      //hover triggers highlight
      if ($.one("circle.active")) {
        $.one("circle.active").classList.remove("active");
      }
      var parcelContainer = $.one(`circle.${data[0].sID}`)
      parcelContainer.classList.add("active");
      parcelContainer.focus();
    }
    else {
      tooltip.classList.remove("show");

    }

  }
  
  // chart.addEventListener("mousemove", onMove);

  //Add additional labels
  var textG = g.append("g").attr("class","text-g")

  var wrapWidth = isMobile.matches ? 130 : 150;

  textG.selectAll("text")
    .data(LABELS).enter().append('text')
        .attr('x', d => xScale(new Date(d.x)))
        .attr('y', d => chartHeight/2)
        .attr('dx', d => isMobile.matches ? d.mobileDx : d.dx)
        .attr('dy', d => isMobile.matches ? d.mobileDy : d.dy)
        .attr('class', d => d.classes)
        .text(d => d.text)
        .call(wrapText, wrapWidth, 15)
}

